import emptyFunction from 'react-utils/emptyFunction';
import { ViewTabsContainer } from '../../tabs/components/ViewTabsContainer';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { Text } from 'foundations-components/components/Text';
import { View } from 'foundations-components/components/View';
import { Flex } from 'foundations-components/components/Flex';
import { jsx as _jsx } from "react/jsx-runtime";
export const PinnedViewsErrorSkeleton = () => {
  return /*#__PURE__*/_jsx(ViewTabsContainer, {
    onReorder: emptyFunction,
    containerRef: emptyFunction,
    children: /*#__PURE__*/_jsx(View, {
      blockSize: "40px",
      backgroundColor: "fill-alert-subtle",
      borderColor: "border-alert-default",
      borderStyle: "solid",
      borderBlockStartWidth: "100",
      borderBlockEndWidth: "0",
      borderInlineStartWidth: "100",
      borderInlineEndWidth: "100",
      children: /*#__PURE__*/_jsx(Flex, {
        alignItems: "center",
        blockSize: "100%",
        inlineSize: "100%",
        children: /*#__PURE__*/_jsx(Text, {
          as: "h5",
          marginInlineStart: "100",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "viewsManagement.pinnedViews.errorMessage"
          })
        })
      })
    })
  });
};